import { g as global, h as hostToEnv, e as envToHosts, A as AppId, C as ClientType } from "./host.js";
export { g as global } from "./host.js";
import UAParser from "ua-parser-js";
import cookie$1 from "js-cookie";
import { p as parseQuery } from "./helpers.js";
const { NAME, VERSION } = UAParser.BROWSER;
const parser = new UAParser({
  browser: [
    [/wegame\.exe.* WeGame\/([\w.]+)/i],
    [VERSION, [NAME, "WeGame PC"]],
    [/tgpapp\/([\w.]+)/i],
    [VERSION, [NAME, "WeGame APP"]],
    [/BiBiGame\/([\w.]+)/i],
    [VERSION, [NAME, "WeGame Electron"]],
    [/QQ\/([\w.]+).* MiniAppEnable/i],
    [VERSION, [NAME, "QQ Mini Program"]],
    [/MicroMessenger\/([\w.]+).* miniProgram.*/i],
    [VERSION, [NAME, "WeChat Mini Program"]]
  ]
});
function parse(ua = global.navigator.userAgent) {
  ua && parser.setUA(ua);
  const res = parser.getResult();
  if (res.browser.name === "QQ" && /MiniAppEnable/i.test(ua)) {
    res.browser.name = "QQ Mini Program";
  }
  if (res.browser.name === "WeChat" && /miniProgram/i.test(ua)) {
    res.browser.name = "WeChat Mini Program";
  }
  return res;
}
var detect = {
  ...parse(),
  parse
};
var cookie = {
  get(name, options) {
    return cookie$1.get(name) || "";
  },
  set(name, value = "", options) {
    cookie$1.set(name, value, options);
  },
  remove(name, options) {
    cookie$1.remove(name, options);
  }
};
const QUERY = parseQuery(window.location.search.slice(1));
const HASH = parseQuery(window.location.hash.slice(1).split("?")[0]);
const HASH_QUERY = parseQuery(window.location.hash.slice(1).split("?")[1]);
const ENV = QUERY.env || hostToEnv(window.location.hostname);
const HOSTS = envToHosts(ENV);
const APP_ID = +QUERY.app_id || AppId.WEGAME;
const CLIENT_TYPE = (() => {
  const query_value = +QUERY.client_type;
  if (ClientType[query_value]) {
    return query_value;
  }
  if (detect.browser.name === "WeGame PC") {
    return ClientType.WEGAME_PC_CLIENT;
  }
  if (detect.browser.name === "WeGame APP") {
    return ClientType.WEGAME_H5;
  }
  if (detect.browser.name === "WeGame Electron") {
    return ClientType.WEGAME_ELECTRON;
  }
  const { pathname } = window.location;
  if (/^\/platform\/social_ingame/.test(pathname)) {
    return ClientType.WEGAME_PC_INGAME;
  }
  if (/^\/platform\/social/.test(pathname)) {
    return ClientType.WEGAME_PC_WEB;
  }
  if (/^\/app\/webibi\//.test(pathname)) {
    return ClientType.WEGAME_H5;
  }
  if (/\/h5\//.test(pathname)) {
    return ClientType.WEGAME_H5;
  }
  if (/\/pc\//.test(pathname)) {
    return ClientType.WEGAME_PC_WEB;
  }
  const cookie_value = +cookie.get("client_type");
  if (ClientType[cookie_value]) {
    return cookie_value;
  }
  if (detect.device.type === "mobile") {
    return ClientType.WEGAME_H5;
  }
  return ClientType.WEGAME_PC_WEB;
})();
var config = {
  QUERY,
  HASH,
  HASH_QUERY,
  ENV,
  HOSTS,
  APP_ID,
  CLIENT_TYPE
};
var storage = {
  get(key) {
    try {
      const value = window.localStorage.getItem(key) || "null";
      return JSON.parse(value);
    } catch (error) {
      console.warn("storage.get():", error);
      return null;
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn("storage.set():", error);
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.warn("storage.remove():", error);
    }
  },
  clear() {
    try {
      window.localStorage.clear();
    } catch (error) {
      console.warn("storage.clear():", error);
    }
  }
};
export { config, cookie, detect, storage };
